/**
 * Makes first character of string uppercase
 * @param str
 * @returns {string}
 */
export function ucFirst(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
